import React, { FC } from 'react';
import { Flex } from '@brightcove/studio-components';

import { ContentData } from '../../../interfaces/Content';
import Panel from '../../../components/Panel/Panel';

interface ContentProps {
  idPanel: string;
  data: ContentData;
}

const Content: FC<ContentProps> = ({ idPanel, data }) => {
  const { id, publicUrl } = data;

  return (
    <div id={idPanel} className="Content">
      <Panel title="Content" actions={<></>}>
        <>
          <Flex>
            <div>
              <div className="ml-4">
                <p className="title">ID</p>
                <p className="description">{id}</p>
              </div>
              <div className="ml-4 mt-6">
                <p className="title">Public URL</p>
                {publicUrl?.length ? (
                  <p className="link">
                    <a href={publicUrl} target="_blank" rel="noreferrer">
                      {publicUrl}
                    </a>
                  </p>
                ) : (
                  '-'
                )}
              </div>
            </div>
          </Flex>
        </>
      </Panel>
    </div>
  );
};

export default Content;
